import React, { useEffect } from 'react';
import { useAppSelector } from '../store/store';
import { getAuthenticatedUserId } from '../store/selector/user.selector';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import FAQPage from '../pages/FAQ/Faq';
import {
    getOrganizationId,
    getOrganizationSubscriptionStatus,
} from '../store/selector/organization.selector';
import { Paddle } from '@paddle/paddle-js';
import PaddleHeaderLayout from '../layouts/PaddleHeaderLayout';
import Paywall from '../components/paywall/Paywall';

interface IProps {
    paddle: Paddle | null;
}

const RoutesContainer = ({ paddle }: IProps) => {
    const authenticatedUserId = useAppSelector(getAuthenticatedUserId);
    const organizationId = useAppSelector(getOrganizationId);
    const organizationSubscriptionStatus = useAppSelector(getOrganizationSubscriptionStatus);

    return (
        <Routes>
            <Route path="/faq" element={<FAQPage />} />

            {authenticatedUserId ? (
                <>
                    {paddle && organizationId && !organizationSubscriptionStatus ? (
                        <>
                            <Route
                                path="/"
                                element={
                                    <PaddleHeaderLayout
                                        children={
                                            <Paywall
                                                show={true}
                                                onHide={() => {}}
                                                paddle={paddle}
                                            />
                                        }
                                    />
                                }
                            />
                            <Route path="*" element={<Navigate to="/" />} />
                        </>
                    ) : (
                        <Route path="/*" element={<PrivateRoutes />} />
                    )}
                </>
            ) : (
                <Route path="/*" element={<PublicRoutes />} />
            )}
        </Routes>
    );
};

export default RoutesContainer;
